
import React from 'react';
import { X } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { FilterOperation } from '@/hooks/useConnectionData';
import ActiveFilterItem from './ActiveFilterItem';

interface ActiveFiltersListProps {
  filters: Array<{ column: string; value: string; operation: FilterOperation }>;
  onRemoveFilter: (column: string, value: string, operation: FilterOperation) => void;
  onClearAllFilters: () => void;
}

const ActiveFiltersList: React.FC<ActiveFiltersListProps> = ({
  filters,
  onRemoveFilter,
  onClearAllFilters
}) => {
  if (filters.length === 0) return null;
  
  return (
    <div className="space-y-2 pt-1 pb-2">
      <div className="text-sm text-muted-foreground">Active filters:</div>
      <div className="flex flex-wrap gap-2">
        {filters.map((filter, index) => (
          <ActiveFilterItem 
            key={index} 
            column={filter.column} 
            value={filter.value} 
            operation={filter.operation}
            onRemove={onRemoveFilter}
          />
        ))}
      </div>
      {filters.length > 0 && (
        <div className="flex justify-end pt-1">
          <Button 
            variant="ghost" 
            size="sm" 
            className="h-7 text-xs flex items-center gap-1" 
            onClick={onClearAllFilters}
          >
            <X size={12} />
            Clear all
          </Button>
        </div>
      )}
    </div>
  );
};

export default ActiveFiltersList;
